export default __webpack_public_path__ + "static/media/closebtn.88cbf7b8.svg";